// Google Analytics 4 — enabled only when REACT_APP_GA4_MEASUREMENT_ID is set
// (G-XXXXXXXXXX) and the visitor has not opted out. No PII is ever sent.
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let loaded = false;

const enabled = () =>
  Boolean(GA_ID) && localStorage.getItem("analytics_opt_out") !== "true";

export const initAnalytics = () => {
  if (!enabled() || loaded) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // manual page_view tracking (SPA); GA4 anonymizes IPs by default
  window.gtag("config", GA_ID, { send_page_view: false });
};

export const trackPageView = (path) => {
  if (!enabled() || !window.gtag) return;
  // include the query string so GA4 captures utm_* campaign/referral
  // attribution on landing pages
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path + window.location.search });
};

export const track = (name, params = {}) => {
  if (!enabled() || !window.gtag) return;
  window.gtag("event", name, params);
};
